import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Server, PlugZap } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { http, errMsg } from "@/lib/api";

export const MinecraftCard = () => {
  const [mc, setMc] = useState(null);
  const [pwd, setPwd] = useState("");
  const [test, setTest] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { http.get("/admin/minecraft").then((r) => setMc(r.data)); }, []);
  if (!mc) return null;

  const save = async (e) => {
    e?.preventDefault();
    const { has_password, ...body } = mc;
    const r = await http.put("/admin/minecraft", { ...body, port: Number(body.port) || 25575, password: pwd });
    setMc(r.data); setPwd("");
    return r.data;
  };
  const onSave = async (e) => {
    try { await save(e); toast.success("Ligação ao servidor salva"); } catch (err) { toast.error(errMsg(err)); }
  };
  const runTest = async () => {
    setBusy(true); setTest(null);
    try { const r = await http.post("/admin/minecraft/test", { command: "list", host: mc.host, port: Number(mc.port) || 25575, password: pwd || null }); setTest({ ok: true, msg: r.data.response || "Conectado (sem resposta)" }); }
    catch (err) { setTest({ ok: false, msg: errMsg(err) }); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={onSave} className="rounded-2xl bg-[#111827] border border-emerald-500/30 p-6 space-y-5" data-testid="admin-minecraft-form">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="font-heading font-bold flex items-center gap-2 text-emerald-300"><Server className="w-4 h-4" /> Servidor Minecraft (entrega automática)</p>
          <p className="text-xs text-slate-400 mt-1">O site liga-se ao seu servidor por RCON e executa os comandos de cada produto com o nick do comprador.</p>
        </div>
        <Switch checked={mc.enabled} onCheckedChange={(v) => setMc({ ...mc, enabled: v })} data-testid="admin-minecraft-enabled-switch" />
      </div>
      <div className="grid sm:grid-cols-3 gap-4">
        <div className="space-y-2 sm:col-span-2"><Label>IP / host do servidor</Label><Input placeholder="ex: 45.12.34.56 ou mc.gugmc.com" value={mc.host} onChange={(e) => setMc({ ...mc, host: e.target.value })} data-testid="admin-minecraft-host-input" /></div>
        <div className="space-y-2"><Label>Porta RCON</Label><Input type="number" value={mc.port} onChange={(e) => setMc({ ...mc, port: e.target.value })} data-testid="admin-minecraft-port-input" /></div>
        <div className="space-y-2 sm:col-span-3"><Label>Senha RCON {mc.has_password && <span className="text-emerald-400 text-xs">(já configurada, deixe vazio para manter)</span>}</Label>
          <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder={mc.has_password ? "••••••••" : "rcon.password do server.properties"} data-testid="admin-minecraft-password-input" /></div>
      </div>
      <div className="flex items-center gap-3"><Switch checked={mc.auto_deliver} onCheckedChange={(v) => setMc({ ...mc, auto_deliver: v })} data-testid="admin-minecraft-auto-switch" /><Label>Enviar itens automaticamente quando eu marcar o pedido como “Pago”</Label></div>
      <div className="rounded-xl bg-white/5 p-4 text-xs text-slate-400 space-y-1">
        <p className="text-slate-300 font-semibold">Como ativar no servidor (server.properties):</p>
        <p className="font-mono">enable-rcon=true · rcon.port=25575 · rcon.password=SUA_SENHA</p>
        <p>Depois reinicie o servidor e libere a porta RCON no painel da sua hospedagem.</p>
      </div>
      {test && <p className={`text-sm font-mono ${test.ok ? "text-emerald-300" : "text-rose-300"}`} data-testid="admin-minecraft-test-result">{test.ok ? "✓ " : "✗ "}{test.msg}</p>}
      <div className="flex flex-wrap gap-3">
        <button className="h-10 px-5 rounded-full bg-emerald-500 hover:bg-emerald-400 text-slate-950 text-sm font-semibold" data-testid="admin-minecraft-save-button">Salvar ligação</button>
        <button type="button" onClick={runTest} disabled={busy} className="h-10 px-5 rounded-full border border-white/15 hover:bg-white/10 text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-50" data-testid="admin-minecraft-test-button">
          <PlugZap className="w-4 h-4" /> {busy ? "Testando..." : "Testar conexão"}
        </button>
      </div>
    </form>
  );
};
